// extracted by mini-css-extract-plugin
module.exports = {"swiperContainer":"VaultStatsTiles_swiperContainer__3gLZP","swiperSlide":"VaultStatsTiles_swiperSlide__2nD56","button":"VaultStatsTiles_button__2mfSD"};